export default __webpack_public_path__ + "devam_ediyor.png";